const changeYotiVerificationStatus = async function (status, changeVerificationStatusUrl) {
  try {
    const requestBody = { verification_status: status }
    const csrfToken = this.$cookies.get('csrftoken')

    if (!csrfToken) {
      throw new Error('CSRF token not found.')
    }
    const headers = {
      'X-CSRFToken': csrfToken,
    }
    const response = await this.$http.post(changeVerificationStatusUrl, requestBody, { headers })

    if (response.status === 200) {
      window.location.reload()
    } else {
      const errorMessage = response.data?.data?.message || 'An unknown error occurred.'
      throw new Error(errorMessage)
    }
  } catch (error) {
    console.error('Error changing verification status:', error.message)
    window.showErrorTopAlertWithTimer()
  }
}

export default changeYotiVerificationStatus
